import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { DateField, TextField } from '../../fields';
import messages from '../../../text/messages';
import WizardButtons from '../../wizard/navigator/buttons';

import './deleteAssignment.css';

class DeleteAssignmentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: true
        };

        this.isFormValid = this.isFormValid.bind(this);
    }

    isFormValid() {
        return true;
    }

    render() {
        const { onSubmit, handleSubmit, cancel, submitting, start_date, end_date } = this.props;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <Field name={'user.first_name'} component={TextField} placeholder={messages.firstName} disabled={true} />
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <Field name="user.last_name" component={TextField} placeholder={messages.lastName} disabled={true} />
                    </div>

                    <div className="col-sm-6 col-xs-12">
                        <Field name="start_date" selectedDate={start_date} component={DateField} placeholder={messages.startDate} disabled={true} />
                    </div>

                    <div className="col-sm-6 col-xs-12">
                        <Field name="end_date" selectedDate={end_date || null} component={DateField} placeholder={messages.endDate} disabled={true} />
                    </div>
                </div>

                <WizardButtons
                    disabled={submitting || !this.isFormValid()}
                    back={{ action: cancel, message: <FormattedMessage {...messages.cancel} /> }}
                    submit={{ message: <FormattedMessage {...messages.delete} />, classes: 'wizard-reject' }}
                />
            </form>
        );
    }
}

DeleteAssignmentForm.defaultProps = {
    job: {},
    onSubmit: undefined
};

DeleteAssignmentForm.propTypes = {
    job: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired
};

DeleteAssignmentForm = reduxForm({
    form: 'delete-form',
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    keepDirtyOnReinitialize: false
})(DeleteAssignmentForm);

const selector = formValueSelector('delete-form');
const mapStateToProps = state =>
    Object.keys((state.form['delete-form'] || { registeredFields: {} }).registeredFields).reduce(
        (props, key) => {
            if (!key.includes('.')) {
                props[key] = selector(state, key);
            }
            return props;
        },
        { fields: (state.form['delete-form'] || { registeredFields: {} }).registeredFields }
    );
export default connect(mapStateToProps)(DeleteAssignmentForm);



// WEBPACK FOOTER //
// ./src/components/forms/deleteAssignment/index.jsx